/*
 * ------------------------------------------------------------------
 * Reset
 * ------------------------------------------------------------------
 */

const resetAppearance = (root) => {
  root.classList.remove(
    "pf-v6-theme-felt",
    "pf-v6-theme-dark",
    "pf-v6-theme-high-contrast",
    "pf-v6-theme-glass"
  );
};

/*
 * ------------------------------------------------------------------
 * Theme
 * ------------------------------------------------------------------
 */

const applyTheme = (root, theme) => {
  switch (theme) {
    case "project-felt":
      root.classList.add("pf-v6-theme-felt");
      break;

    default:
      break;
  }
};

/*
 * ------------------------------------------------------------------
 * Color scheme
 * ------------------------------------------------------------------
 */

// const applyColorScheme = (root, colorScheme) => {
//   switch (colorScheme) {
//     case "dark":
//       root.classList.add("pf-v6-theme-dark");
//       break;

//     case "system":
//       if (
//         window.matchMedia("(prefers-color-scheme: dark)").matches
//       ) {
//         root.classList.add("pf-v6-theme-dark");
//       }
//       break;

//     default:
//       break;
//   }
// };
const applyColorScheme = (root, colorScheme) => {
  switch (colorScheme) {
    case "dark":
      root.dataset.colorScheme = "dark";
      root.classList.add("pf-v6-theme-dark");
      break;

    case "system": {
      const dark = window.matchMedia("(prefers-color-scheme: dark)").matches;

      root.dataset.colorScheme = dark ? "dark" : "light";

      if (dark) {
        root.classList.add("pf-v6-theme-dark");
      }
      break;
    }

    default:
      root.dataset.colorScheme = "light";
      break;
  }
};

/*
 * ------------------------------------------------------------------
 * Contrast mode
 * ------------------------------------------------------------------
 */

const applyContrastMode = (root, contrastMode) => {
  switch (contrastMode) {
    case "high-contrast":
      root.classList.add("pf-v6-theme-high-contrast");
      break;

    case "glass":
      root.classList.add("pf-v6-theme-glass");
      break;

    case "system": {
      const prefersHighContrast =
        window.matchMedia("(prefers-contrast: more)").matches ||
        window.matchMedia("(forced-colors: active)").matches;

      if (prefersHighContrast) {
        root.classList.add("pf-v6-theme-high-contrast");
      }

      break;
    }

    default:
      break;
  }
};

/*
 * ------------------------------------------------------------------
 * Apply appearance
 * ------------------------------------------------------------------
 */

const applyAppearance = ({
  theme,
  colorScheme,
  contrastMode,
}) => {
  const root = document.documentElement;

  resetAppearance(root);

  applyTheme(root, theme);

  applyColorScheme(root, colorScheme);

  applyContrastMode(root, contrastMode);
};

export default applyAppearance;